import React, { useState, useEffect } from "react";

const CompTitleRow = ({ spec, editing, expanded, save, cancel, del, edit }) => {
  let id;
  if (expanded) id = <div className="CompId">{spec.get("id")}</div>;
  if (editing) {
    return (
      <div className="ViewTitleRow">
        {id}
        <div
          className="AddUiViewConfirm"
          onClick={e => {
            e.stopPropagation();
            save();
          }}
        />
        <div
          className="AddUiViewCancel"
          onClick={e => {
            e.stopPropagation();
            cancel();
          }}
        />
        <div
          className="ViewDelete"
          onClick={e => {
            e.stopPropagation();
            del();
          }}
        />
      </div>
    );
  } else {
    return (
      <div className="ViewTitleRow">
        {id}
        <div
          className="ViewEdit"
          onClick={e => {
            e.stopPropagation();
            edit();
          }}
        />
      </div>
    );
  }
};
export default CompTitleRow;



// WEBPACK FOOTER //
// ./src/components/CompTitleRow.js